<table mat-table [dataSource]="dataSource">
  <!-- Title Column -->
  <ng-container matColumnDef="title">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element"> <b>{{element.title}}</b> </td>
  </ng-container>

  <!-- With Leverage Column -->
  <ng-container matColumnDef="withLeverage">
    <th mat-header-cell *matHeaderCellDef>With Leverage</th>
    <td mat-cell class="colored" *matCellDef="let element"> {{element.withLeverage}} </td>
  </ng-container>

  <!-- Without Leverage Column -->
  <ng-container matColumnDef="withoutLeverage">
    <th mat-header-cell *matHeaderCellDef>Without Leverage</th>
    <td mat-cell class="colored" *matCellDef="let element"> {{element.withoutLeverage}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
